"use client";
import React from "react";

import useContactUs from "./useContactUs";

import { ContactCard, ContactForm } from "@/components";

const ContactUs = () => {
  const { contactParams } = useContactUs();

  return (
    <div className=" min-h-screen py-10 max-w-screen-2xl mx-auto lg:px-28 px-6">
      <div className="italic text-2xl text-primary font-medium">Contact Us</div>
      <div className="flex gap-8 lg:flex-row flex-col-reverse lg:mt-8 mt-5">
        <div className="lg:w-6/12 ">
          {/* Desktop to info */}
          <div className="hidden lg:block mb-4">
            <div
              className="text-foreground  text-5xl tracking-wide max-w-lg font-medium"
              data-aos="fade-up"
            >
              We’re here to answer your questions and connect with you!
            </div>
            <div
              className="text-foreground-600 text-lg mt-4"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              Let us know how we can help you.
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-4 mt-8 lg:max-w-xl">
            {contactParams.map((data, index) => (
              <ContactCard key={index} data={data} />
            ))}
          </div>
        </div>
        <div className="lg:w-6/12">
          {/* Mobile to info */}
          <div className="lg:hidden block mb-8">
            <div
              className="text-foreground lg:text-5xl md:text-6xl text-2xl tracking-wide font-medium"
              data-aos="fade-up"
            >
              We’re here to answer your questions and connect with you!
            </div>
            <div
              className="text-foreground-600 text-base mt-3"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              Let us know how we can help you.
            </div>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
